import { $api } from './interceptor';
import {
  resetPasswordChangedToastFlag,
  resetAdminDeactivatedToastFlag,
} from '../../services/authErrorHandler';

const SignIn = () => {
  const sendLoginRequest = async (email: string, password: string) => {
    const response = await $api.post('/api/auth/admin', {
      login: email,
      password,
    });

    const accessToken = response?.data?.tokens?.access;

    if (accessToken) {
      localStorage.setItem('accessToken', accessToken);
      resetPasswordChangedToastFlag();
      resetAdminDeactivatedToastFlag();
    }
  };

  const logout = async () => {
    await $api.post('/api/auth/logout');
    localStorage.removeItem('accessToken');
  };

  const sendRefreshRequest = async () => {
    try {
      const storageAccessToken = localStorage.getItem('accessToken');
      if (!storageAccessToken) throw new Error('No access token');

      const resp = await $api.post(
        `/api/auth/refresh`,
        {},
        {
          withCredentials: true,
          headers: {
            Authorization: `${storageAccessToken}`,
          },
        }
      );
      const accessToken = resp.data.access;
      localStorage.setItem('accessToken', accessToken);
      resetPasswordChangedToastFlag();
      resetAdminDeactivatedToastFlag();
      return true;
    } catch (e) {
      localStorage.removeItem('accessToken');
      throw e;
    }
  };

  return {
    sendLoginRequest,
    logout,
    sendRefreshRequest,
  };
};

export const signInService = SignIn();
